import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable, of } from 'rxjs';
import { catchError, map, mergeMap, switchMap } from 'rxjs/operators';
import { DocumentService } from '../entity-document-tree.service';
import * as documentActions from './document.action';
import { Action } from '@ngrx/store';

@Injectable()
export class DocumentEffects {
  constructor(
    private actions$: Actions,
    private documentService: DocumentService
  ) { }

  loadDocuments$ = createEffect(() => this.actions$.pipe(
    ofType(documentActions.EntityDocumentActionTypes.LoadEntityDocument),
    map((action: documentActions.loadDocuments) => action.keyword),
    switchMap(keyword =>
      this.documentService.getDocuments(keyword).pipe(
        map(documents => (new documentActions.loadDocumentsSuccess(documents))),
        catchError(err => of(new documentActions.loadDocumentsFailure(err)))
      )
    )
  ));

  loadSiteLogoImg$ = createEffect(() => this.actions$.pipe(
    ofType(documentActions.EntityDocumentActionTypes.LoadDocumentViewerConfiguration),
    switchMap(() =>
      this.documentService.getDocumentViewerConfiguration().pipe(
        map(setting => new documentActions.loadDocumentViewerConfigurationSuccess(setting)),
        catchError(err => of(new documentActions.loadDocumentViewerConfigurationFail(err)))
      )
    )
  ));
}